var _rect, _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgAiTag = function SvgAiTag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 18",
    fill: "currentColor"
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 18,
    rx: 6,
    fill: "#EBF2FA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "ai-tag_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 2,
    width: 15,
    height: 14
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.75 13.5a1.5 1.5 0 011.5 1.5 1.5 1.5 0 011.5-1.5 1.5 1.5 0 01-1.5-1.5 1.5 1.5 0 01-1.5 1.5zm0-9a1.5 1.5 0 011.5 1.5 1.5 1.5 0 011.5-1.5 1.5 1.5 0 01-1.5-1.5 1.5 1.5 0 01-1.5 1.5zm-5.25 9A4.5 4.5 0 0114 9a4.5 4.5 0 01-4.5-4.5A4.5 4.5 0 015 9a4.5 4.5 0 014.5 4.5z",
    fill: "#D61D6F",
    stroke: "#D61D6F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ai-tag_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#ai-tag_svg__ai-tag_svg__paint0_linear_5097_19362)",
    d: "M0 0h24v18H0z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ai-tag_svg__ai-tag_svg__paint0_linear_5097_19362",
    x1: 0,
    y1: 7.78,
    x2: 24.001,
    y2: 7.854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F31779"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#7930D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C6FE8"
  })))));
};
export default SvgAiTag;